<template>
  <!-- About -->

  <section class="about">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h2 class="section-title">Про салон краси La Rose</h2>
        </div>
      </div>
      <div class="about-cont row align-items-center">
        <div class="col-6">
          <p class="about-text">
            Салон краси La Rose у Чернівцях належить до числа ексклюзивних експерт-салонів "Loreal Salon Expert" i відзначається високою професійністю майстрів та використанням у роботі креативних ідей.
            Кожна дівчина красива по-своєму. І, звичайно, кожна прагне стати ще прекраснішою!
            Підтримування свого зовнішнього вигляду на високому рівні – не просте завдання, яке вимагає багато зусиль і часу. Але милим дівчатам пощастило, у них є помічники – майстри візажу та манікюру, перукарі та стилісти.<br><br>

            Це оселя тих чарівників, які допоможуть усім клієнтам досягти досконалості.
            Наші майстри беруть на себе всі турботи і складні завдання у сфері краси та догляду за собою. Потрібен весільний макіяж для головного свята в житті? Захотілося змінити колір волосся? Душа бажає нового яскравого манікюру? Ніяких проблем – звертайтеся до нас!<br><br>

            Наші майстри регулярно стажуються в школах перукарської майстерності з світовими іменами. Для нас важливо, щоб вас обслуговували кращі майстри.
            Ми працюємо тільки з тими, хто вже зарекомендув своє ім’я в сфері краси, догляду та здоров’я. Серед них: Patrice beute’, Kemon NaYo, Kemon Cramer Color.
            Наш салон — це цілий світ бездоганного сервісу і унікального інтер’єру, що створює атмосферу відпочинку та релаксації. З Daniel ви завжди будете виглядати чудово, а кожен похід в салон краси стане справжнім святом.
          </p>
        </div>
        <div class="col-6">
          <img src="img/about-img.jpg" alt="#" class="about-img">
        </div>
      </div>
    </div>
  </section>






</template>

<script>
    export default {
        name: "AboutMore"
    }
</script>

<style scoped>

</style>
